import { NavState, fetchNavState } from '@amzn/aac-chrome-internal-api';
import ChromeInternalApiRequestConfig from './chrome-internal-api-request-config';

export default async (): Promise<NavState> => {
  if (window.AACChrome?.InternalAPI) {
    return window.AACChrome.InternalAPI.NavStateHandler.getInstance().getNavState(
      ChromeInternalApiRequestConfig,
    );
  }
  return fetchNavState(ChromeInternalApiRequestConfig);
};
